export enum Languages {
  English = 'en',
  Norwegian = 'nb',
}
